import { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, TextField, CircularProgress, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const modalStyle = {
    position: 'absolute', top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)', width: 600,
    bgcolor: 'background.paper', border: '2px solid #000',
    boxShadow: 24, p: 4,
};

export default function ModifyFaqModal({ open, onClose, faq, customer, onSubmit }) {
    const [faqId, setFaqId] = useState('');
    const [content, setContent] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (open && faq) {
            setFaqId(faq.id || '');
            setContent(faq.content || '');
            setError('');
        }
    }, [open, faq]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!faqId || !content) {
            setError('All fields are required.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        const payload = {
            faq_id: faqId,
            client_name: customer.ClientName,
            content: content,
            last_updated_by: 'x-placeholder-user',
            timestamp: new Date().toISOString()
        };
        try {
            await onSubmit(payload);
        } catch (e) {
            setError(e.message || 'An unexpected error occurred.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle} component="form" onSubmit={handleSubmit}>
                <Typography variant="h6" component="h2">Modify FAQ</Typography>
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                
                <FormControl fullWidth sx={{ mt: 2 }} disabled>
                    <InputLabel>FAQ ID</InputLabel>
                    <Select value={faqId} label="FAQ ID" onChange={(e) => setFaqId(e.target.value)}>
                        <MenuItem value={faq?.id}>{faq?.id}</MenuItem>
                    </Select>
                </FormControl>

                <TextField label="Client Name" value={customer ? customer.ClientName : ''} fullWidth disabled sx={{ mt: 2 }} />
                <TextField
                    label="Content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    fullWidth required multiline rows={4} sx={{ mt: 2 }}
                />
                <TextField label="Last Updated By" value="x-placeholder-user" fullWidth disabled sx={{ mt: 2 }} />
                <TextField label="Timestamp" value="Will be set on submit" fullWidth disabled sx={{ mt: 2 }} />

                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={onClose} disabled={isSubmitting}>Cancel</Button>
                    <Button type="submit" variant="contained" disabled={isSubmitting}>
                        {isSubmitting ? <CircularProgress size={24} /> : 'Submit'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
